import GrailedAPIError from "storefront/GrailedAPI/Error";

/**
 * Works out whether a failed API response came from Cloudflare or from our own stack. Envoy or
 * Rails stamps `x-request-id` on everything that reaches our infrastructure, so a response
 * carrying only a Ray ID was generated at the edge — a WAF block page, a challenge, or an edge
 * 5xx. The Ray ID identifies that request in Cloudflare's Security Events, which is where the
 * rule that matched it is named.
 */
export type GrailedAPIErrorSource = {
  origin: "cloudflare" | "grailed" | "unknown";
  rayId: string | null;
  contentType: string | null;
};

export const grailedAPIErrorSource = (
  error: GrailedAPIError,
): GrailedAPIErrorSource => {
  const { headers } = error.response;

  const rayId = headers?.get("cf-ray") || null;
  const contentType = headers?.get("content-type") || null;

  if (headers?.get("x-request-id"))
    return { origin: "grailed", rayId, contentType };

  if (rayId) return { origin: "cloudflare", rayId, contentType };

  return { origin: "unknown", rayId, contentType };
};
